import { cx } from "@linaria/core";
import type { RefObject } from "react";
import React, { Fragment } from "react";

import * as css from "./atom.slide-caption.style";
import { Slide } from "@courses-pm2/api";
import { textColumnCls } from "@pm2/compat";

type Props = {
  ref?: RefObject<HTMLDivElement | null>;

  caption: Slide["caption"] | undefined;
};

const PUNCTUATION_REGEX = /[.,!?]\s*$/;

export function SlideCaption(props: Props): React.JSX.Element | null {
  const displayCaption =
    !!props.caption?.title ||
    !!props.caption?.description ||
    !!props.caption?.authorOrArtist ||
    !!props.caption?.year ||
    !!props.caption?.copyright;

  if (!displayCaption) {
    return <div ref={props.ref} />;
  }

  const caption = [
    props.caption?.title && (
      <span
        key="title"
        className={cx(css.titleCls, css.spanCls)}
        dangerouslySetInnerHTML={{ __html: props.caption.title }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.title)}
      />
    ),
    props.caption?.description && (
      <span
        key="description"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.description }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.description)}
      />
    ),
    props.caption?.authorOrArtist && (
      <span
        key="authorOrArtist"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.authorOrArtist }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.authorOrArtist)}
      />
    ),
    props.caption?.copyright && (
      <span
        key="copyright"
        className={css.spanCls}
        dangerouslySetInnerHTML={{
          __html: "©&nbsp;" + props.caption.copyright,
        }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.copyright)}
      />
    ),
  ].filter((it): it is React.JSX.Element => !!it);

  return (
    <span ref={props.ref} className={cx(css.captionCls, textColumnCls)}>
      <span className={css.contentCls}>
        {caption.map((it, index) => (
          <Fragment key={index}>
            {it}
            {index < caption.length - 1 &&
              (it.props["data-comma"] === true ? ", " : " ")}
          </Fragment>
        ))}
      </span>
    </span>
  );
}
